<template>
    <div>
        <div class="setting-top">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: './setting' }">系统设置</el-breadcrumb-item>
                <el-breadcrumb-item>个人信息管理</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="page-content">
            <div class="form">
                <div class="form-box">
                    <h2>个人信息管理</h2>
                    <div v-if="userinfo">
                        <mu-form :model="userinfo" class="mu-demo-form"  label-width="100">
                            <mu-form-item prop="input" label="账号">
                                <mu-text-field :disabled="true" v-model="userinfo.username"></mu-text-field>
                            </mu-form-item>
                            <mu-form-item prop="input" label="密码">
                                <mu-text-field :disabled="true" value="******"></mu-text-field>
                            </mu-form-item>
                            <mu-form-item prop="input" label="用户角色">
                                <mu-text-field :disabled="true" v-model="userinfo.role_name"></mu-text-field>
                            </mu-form-item>
                            <mu-form-item prop="input" label="用户姓名">
                                <mu-text-field :disabled="true" v-model="userinfo.realname"></mu-text-field>
                            </mu-form-item>
                            <mu-form-item>
                                <mu-button  @click="back">返回</mu-button>
                                <mu-button color="primary" @click="edit">修改</mu-button>
                            </mu-form-item>
                        </mu-form>
                    </div>
                </div>
            </div>
        </div>
        <el-dialog
                title="用户信息修改"
                :visible.sync="dialogVisible"
                width="400px"
                v-if="form"
                >

            <el-form ref="form" :model="form" label-width="100px" :rules="rules">
                <el-form-item label="账号">
                    <el-input v-model="form.username" :disabled="true" style="width: 200px;"></el-input>
                </el-form-item>
                <el-form-item label="密码">
                    <el-input type="password" v-model="form.password"  style="width: 200px;"></el-input>
                </el-form-item>
                <el-form-item label="用户角色">
                    <el-input v-model="form.role_name" :disabled="true"  style="width: 200px;"></el-input>
                </el-form-item>
                <el-form-item label="用户姓名" prop="realname">
                    <el-input v-model="form.realname"  style="width: 200px;"></el-input>
                </el-form-item>
                <el-form-item label="用户手机号" prop="mobile">
                    <el-input v-model="form.mobile"  style="width: 200px;"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="editInfo">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import {getUserinfo,updateUserinfo} from '../../api/role'
    export default {
        name: "edit",
        data() {
            var checkPhone = (rule, value, callback) => {
                if (!value) {
                    return callback(new Error('手机号码不能为空'));
                }
                setTimeout(() => {
                    if (!/^[1][0-9]{10}$/.test(value)) {
                        callback(new Error('请输入正确的手机号码'));
                    } else {
                        callback();
                    }
                }, 500);
            };
            return {
                dialogVisible:false,
                userinfo:null,
                form:{
                    username:'',
                    role_name:'',
                    password:'',
                    mobile:'',
                    realname:''
                },
                rules:{
                    mobile:[
                        { required: true, message: '请输入电话号码', trigger: 'blur' },
                        { validator: checkPhone, trigger: 'blur' }
                    ],
                    password:[
                        { required: true, message: '请输入密码', trigger: 'blur' },
                    ],
                    realname:[
                        { required: true, message: '请输入用户名', trigger: 'blur' },
                    ],
                }
            };
        },
        mounted(){
            this.getUserinfo();

        },
        methods: {
            back(){
                this.$router.push({path:'./setting'})
            },
            edit(){
                this.dialogVisible=true;
                this.form.username=this.userinfo.username;
                this.form.role_name=this.userinfo.role_name;
                this.form.mobile=this.userinfo.mobile;
                this.form.realname=this.userinfo.realname;
                this.form.admin_id=this.userinfo.admin_id;
                this.form.role_id=this.userinfo.role_id;
                this.form.status=this.userinfo.status;
                this.form.password='``````';
            },
            getUserinfo(){
                getUserinfo().then(res=>{
                    if(res.code==1){
                        this.userinfo=res.data;
                        this.userinfo.password='******'
                    }
                })
            },
            editInfo(){
                if(this.form.password=='``````'){
                    this.form.password=''
                }
                updateUserinfo(this.form).then(res=>{
                    if(res.code==1){
                        this.$message.success('修改成功');
                        this.getUserinfo();
                        this.dialogVisible=false;
                    }
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    .setting-top{
        padding: 20px 0 0 20px;
    }
    .page-content{
        padding: 20px 40px;
        .form{
            padding: 20px;
            background-color: #fff;
            text-align: left;
            width: 100%;
            .form-box{
                width: 600px;
            }
        }
    }
</style>
